<canvas id="canvas">{{ chart }}</canvas>